import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VpcBaseIndex from "../base/vpc/index.vue";
import apiRequest from '../../service/vpc/request';
import trustApiRequest from '../../service/trust_vpc/request';
import whiteList from "../../service/common/whiteList";
import { Tabs, Tab } from 'kpc/components/tabs';
import Input from 'kpc/components/input';
import { Form, FormItem } from "kpc/components/form";
import Tooltip from 'kpc/components/tooltip';
import { Button, ButtonGroup } from 'kpc/components/button';
import { Table, TableColumn } from 'kpc/components/table';
import Icon from 'kpc/components/icon';
import { Select, Option } from 'kpc/components/select';
import Tip from 'kpc/components/tip';
import Message from 'kpc/components/message';
import { Row, Col } from 'kpc/components/grid';
import Pagination from 'kpc/components/pagination';

import vpcData from "../../service/vpc/vpcData";
import CopyIcon from '../../components/CopyIcon/index.vue';
import KpcViewTitle from "../../components/KpcViewTitle/index.vue";
import TableColumnEdit from "../../components/TableColumnEdit/index.vue";
import commonApiRequest from "../../service/common/apiRequest";

import * as _ from 'lodash';

@Component({
    components: {
        Tooltip,
        Table,
        TableColumn,
        KpcViewTitle,
        TableColumnEdit,
        Pagination,
        Input,
        Form, FormItem,
        Select, Option,
        Row, Col,
        CopyIcon,
        Button, ButtonGroup,
        Icon,
        Tabs, Tab,
        Tip
    },
    mixins: [VpcBaseIndex]
})
export default class CloneGroupView extends Vue {
    subs: any[] = [];
    fromName = '';
    type = '';
    tableTitle = '';
    inputPlaceHolder = '';
    viewLeftTip = '';
    viewRightTip = '';
    searchData = '';
    searchDataTwo = '';
    regionList: any[] = [];
    leftData: any[] = [];
    leftDataClone: any[] = [];
    leftAllData: any[] = [];
    leftAllDataClone: any[] = [];
    rightData: any[] = [];
    rightDataClone: any[] = [];
    rightAllData: any[] = [];
    rightAllDataClone: any[] = [];
    networkListAll: any[] = [];
    rightDataChecked: any[] = [];
    checkedLeftRows: any = {};
    checkedRightRows: any = {};
    EipBindGroupNum: number = 0;
    sgSupportEpcDeny = false;
    SubTypeAll = {
        primary: Vue.$trans(`主网卡`),
        extension: Vue.$trans(`辅网卡`)
    };
    leftPages: any = {
        current: 1,
        total: 0,
        limit: 10,
        size: 'small' //指定组件的尺寸：large, default, small, mini
    };
    rightPages: any = {
        current: 1,
        total: 0,
        limit: 10,
        size: 'small' //指定组件的尺寸：large, default, small, mini
    };
    pagination: any = {
        enabled: false
    };
    isIncludeDeny = false;

    get request() {
        return this.isTrustVpc ? trustApiRequest : apiRequest
    }

    get backRoute(){
        return this.isTrustVpc ? '#/trust-vpc/group' : '#/vpc/group'
    }


    @Watch("leftPages", {
        deep: true
    })
    LeftPagesWatcher(val: any, oldVal: any) {
        let me: any = this;
        val.current != oldVal.current ? me.refreshLeftData() : undefined;
        val.limit != oldVal.limit ? (me.leftPages.current = 1, me.refreshLeftData()) : undefined;
    }

    @Watch("rightPages", {
        deep: true
    })
    RightPagesWatcher(val: any, oldVal: any) {
        let me: any = this;
        val.current != oldVal.current ? me.refreshRightData() : undefined;
        val.limit != oldVal.limit ? (me.rightPages.current = 1, me.refreshRightData()) : undefined;
    }

    get regionAvailable():any {
        const me:any = this;
        if (!me.region) {
            return true;
        }
        let type = "securityGroupsSearchSortExport";
        return whiteList.check(type, me.region);
    }

    created() {
        let me: any = this;
        me.type = me.$route.params.type;
        me.region = me.$route.params.region;
        me.vpcId = me.$route.params.vpcId;
        me.groupId = me.$route.params.groupId;
        me.groupName = decodeURIComponent(me.$route.params.groupName);
        localStorage.sgId = me.$route.params.groupId;
        localStorage.rule = 'manger';

        if (me.type == "kec") {
            me.subs = [
                { title: me.$trans(`管理云服务器`) + "（" + me.groupName + "）" }
            ];
            me.tableTitle = me.$trans(`管理云服务器`);
            me.inputPlaceHolder = me.$trans(`输入IP、云服务器ID、云服务器名称可进行查询（以逗号分隔）`);
            me.viewLeftTip = me.$trans(`未加入此安全组的网卡`);
            me.viewRightTip = me.$trans(`已加入此安全组的网卡`);
        } else {
            me.subs = [
                { title: me.$trans(`管理裸金属服务器`) + "（" + me.groupName + "）" }
            ];
            me.tableTitle = me.$trans(`管理裸金属服务器`);
            me.inputPlaceHolder = me.$trans(`输入IP、裸金属服务器ID、裸金属服务器名称可进行查询（以逗号分隔）`);
            me.viewLeftTip = me.$trans(`未加入此安全组的裸金属服务器`);
            me.viewRightTip = me.$trans(`已加入此安全组的裸金属服务器`);
        }



    }

    refreshLeftData() {
        let me: any = this;
        let current = me.leftPages.current;
        let limit = me.leftPages.limit;
        let leftData = _.filter(me.leftAllData, (item, index: number) => {
            return index >= (current - 1) * limit && index < current * limit;
        });
        me.leftDataClone = leftData;
    }

    refreshRightData() {
        let me: any = this;
        let current = me.rightPages.current;
        let limit = me.rightPages.limit;
        let rightData = _.filter(me.rightAllData, (item, index: number) => {
            return index >= (current - 1) * limit && index < current * limit;
        });
        me.rightDataClone = rightData;
    }

    getSgSupportEpcDeny() {
        let me: any = this;
        // 安全组deny规则是否支持epc。1、不支持；2、支持
        commonApiRequest.DescribeQuotaByName({
            Region: me.region,
            QuotaName: "quota_vpc_securitygroupepcdeny"
        })
        .done((data: any) => {
            if (data && data.QuotaMax) {
                this.sgSupportEpcDeny = (data.QuotaMax == 2 || me.type == "kec") ? true : false;
            }
        });
    }

    DescribeSecurityGroups() {
        let me: any = this;
        // apiRequest.DescribeSecurityGroups({
        this.request.DescribeSecurityGroups({
            Region: me.region,
            'SecurityGroupId.1': me.groupId
        }).done((data: any) => {
            let detail = _.get(data, 'SecurityGroupSet[0]', {});
            let SecurityGroupEntrySet = _.get(detail, 'SecurityGroupEntrySet');
            
            // 判断是否含Deny规则
            let dropObj = _.find(SecurityGroupEntrySet, (item) => {
                return item.Policy == 'Drop';
            }) || {};
            
            if (dropObj && dropObj.SecurityGroupEntryId) {
                me.isIncludeDeny = true;
            } else {
                me.isIncludeDeny = false;
            }
        });
    }

    getList() {
        let me: any = this;
        me.getSgSupportEpcDeny();
        me.DescribeSecurityGroups();
        me.checkEipBindGroupPermission();
    }

    checkEipBindGroupPermission() {
        let me: any = this;

        // 弹性网卡(KEC&EPC)支持绑定安全组数量Quota
        // let quotaName = '';
        // if (me.type == "kec") {
        //     quotaName = "quota_kec_secgroup";
        // } else {
        //     quotaName = "quota_vpc_enicountepc";
        // }
        // commonApiRequest.DescribeQuotaByName({
        //     Region: me.region,
        //     QuotaName: quotaName
        // }).done((data: any) => {
        //     // console.log(data.QuotaMax, "data.QuotaMax===================");
        //     this.EipBindGroupNum = data.QuotaMax;
        //     if (me.type == "kec") {
        //         me.moreKecSafeShow();
        //     } else {
        //         me.moreEpcSafeShow();
        //     }
        // });
        if (me.type == "kec") {
            this.EipBindGroupNum = 5;
            me.moreKecSafeShow();
        } else {
            this.EipBindGroupNum = 3;
            me.moreEpcSafeShow();
        }
    }

    searchAll(type: any) {
        let me: any = this;
        let str = '';
        if (!me.searchData.replace(/\s+/g, "")) {
            me.leftAllData = me.leftAllDataClone;
            me.leftPages.total = 0;
            me.refreshLeftData();
            return;
        }

        let searchAll: any[] = [];
        me.searchData = me.searchData.replace(/[\r\n]/g, ",");
        if (me.searchData.indexOf('，') != -1) {
            str = me.searchData.replace("，", ",");
        } else {
            str = me.searchData;
        }

        let arr = str.split(',');

        _.forEach(arr, (item) => {
            let val = item.replace(/\s+/g, "");
            _.forEach(me.leftAllDataClone, (itemCol) => {
                if (type === '1') { //1为模糊查询 0为精确查询
                    if (_.includes(itemCol.InstanceId, val) || _.includes(itemCol.NetworkInterfaceId, val) || _.includes(itemCol.PrivateIpAddress, val) || _.includes(itemCol.InstanceName, val)) {
                        let repeat = _.find(searchAll, ['NetworkInterfaceId', itemCol.NetworkInterfaceId]);
                        if (!repeat) {
                            searchAll.push(itemCol)
                        }
                    }
                } else {
                    if (itemCol.InstanceId === val || itemCol.NetworkInterfaceId === val || itemCol.PrivateIpAddress === val || itemCol.InstanceName === val) {
                        let repeat = _.find(searchAll, ['NetworkInterfaceId', itemCol.NetworkInterfaceId]);
                        if (!repeat) {
                            searchAll.push(itemCol)
                        }
                    }
                }

            })
        });
        me.leftPages.total = searchAll.length;
        me.leftAllData = searchAll;
        me.refreshLeftData();

    }

    // 新加的
    searchAllRight(type: any) {
        let me: any = this;
        let str = '';
        console.log(this.searchDataTwo, me.rightAllDataClone);
        if (!me.searchDataTwo.replace(/\s+/g, "")) {
            me.rightAllData = me.rightAllDataClone;
            me.rightPages.total = 0;
            me.refreshRightData();
            return;
        }
        
        let searchAll: any[] = [];
        me.searchDataTwo = me.searchDataTwo.replace(/[\r\n]/g, ",");
        if (me.searchDataTwo.indexOf('，') != -1) {
            str = me.searchDataTwo.replace("，", ",");
        } else {
            str = me.searchDataTwo;
        }

        let arr = str.split(',');
        _.forEach(arr, (item) => {
            let val = item.replace(/\s+/g, "");
            _.forEach(me.rightAllDataClone, (itemCol) => {
                if (type === '1') { //1为模糊查询 0为精确查询
                    if (_.includes(itemCol.InstanceId, val) || _.includes(itemCol.NetworkInterfaceId, val) || _.includes(itemCol.PrivateIpAddress, val) || _.includes(itemCol.InstanceName, val)) {
                        let repeat = _.find(searchAll, ['NetworkInterfaceId', itemCol.NetworkInterfaceId]);
                        if (!repeat) {
                            searchAll.push(itemCol)
                        }
                    }
                } else {
                    if (itemCol.InstanceId === val || itemCol.NetworkInterfaceId === val || itemCol.PrivateIpAddress === val || itemCol.InstanceName === val) {
                        let repeat = _.find(searchAll, ['NetworkInterfaceId', itemCol.NetworkInterfaceId]);
                        if (!repeat) {
                            searchAll.push(itemCol)
                        }
                    }
                }

            })
        });
        me.rightPages.total = searchAll.length;
        me.rightAllData = searchAll;
        me.refreshRightData();

    }

    DescribeNetworkInterfacesExtendLoop(param: any, res: any, nextToken: any, cb: any) {
        let me:any = this;
        let NextToken = '';
        if (nextToken) {
            NextToken = nextToken;
        }
        let params: any;
        if (param) {
            params = param;
            params.maxResults = 1000;
            params.NextToken = NextToken;
        } else {
            params = {
                Region: me.region,
                maxResults: 1000,
                NextToken
            };
    
            if(me.vpcId != 0) {
                params['Filter.1.Name'] = 'vpc-id';
                params['Filter.1.Value.1'] = me.vpcId;
            }
        }
        

        // apiRequest.DescribeNetworkInterfaces(params).done((data: any) => {
        this.request.DescribeNetworkInterfaces(params).done((data: any) => {
            res = res.concat(data.NetworkInterfaceSet || []);
            if (res.length >= data.TotalCount) {
                cb(res)
            } else {
                this.DescribeNetworkInterfacesExtendLoop(param, res, data.NextToken, cb);
            }
        })
    }

    DescribeNetworkInterfacesExtend(param: any = null) {
        return new Promise(resolve => {
            this.DescribeNetworkInterfacesExtendLoop(param, [], null, (res: any) => {
                resolve({
                    NetworkInterfaceSet: res
                });
            })
        })
    }

    DescribeNetworkInterfacesExtendFirst() {
        let me:any = this;
        let NextToken = '';
        
        let params:any = {
            Region: me.region,
            maxResults: 1000,
            NextToken
        };

        if(me.vpcId != 0) {
            params['Filter.1.Name'] = 'vpc-id';
            params['Filter.1.Value.1'] = me.vpcId;
        }

        return new Promise(resolve => {
            apiRequest.DescribeNetworkInterfaces(params).done((data: any) => {
                resolve({
                    NetworkInterfaceSet: data.NetworkInterfaceSet || []
                });
            })
        })
    }

    filter(data: any, keywords: any) {
        return data.InstanceName.includes(keywords) || data.InstanceId.includes(keywords) || data.PrivateIpAddress.includes(keywords);
    }

    //多安全组添加
    addMethod() {
        let me: any = this;
        if (!me.checkedLeftRows.length) {
            Message.error(this.$trans(`请选择`));
            return;
        }
        let checkedLeftRowIds = _.map(me.checkedLeftRows, 'NetworkInterfaceId')
        let notAddList: any[] = [];
        let addList: any[] = [];
        _.forEach(me.leftDataClone, function (item, index) {
            if (_.includes(checkedLeftRowIds, item.NetworkInterfaceId)) {
                item.SecurityGroupSet.push(me.groupId)
                // me.rightDataClone.unshift(item)
                addList.push(item);
            } else {
                notAddList.push(item);
            }
        })
        // me.leftDataClone = notAddList;

        let allNotAddList = _.filter(me.leftAllData, (item) => {
            return !_.includes(checkedLeftRowIds, item.NetworkInterfaceId);
        });
        me.leftAllData = allNotAddList;
        me.leftAllDataClone = allNotAddList;
        me.leftPages.total = allNotAddList.length;
        me.refreshLeftData();

        // me.rightDataClone = addList.concat(me.rightDataClone);
        me.rightAllData = addList.concat(me.rightAllData);
        me.rightAllDataClone =  _.cloneDeep(me.rightAllData);
        me.rightPages.total = me.rightAllData.length;
        me.refreshRightData();

    }

    //多安全组移除：已加入移除到未加入时,要把现有的安全组ID移除 
    //SecurityGroupSet.length==1不可移除
    //多安全组添加:未加入添加到已加入,要把现有的安全组ID添加到SecurityGroupSet里 
    //SecurityGroupSet>=5不可添加
    rmMethod() {
        let me: any = this;
        if (!me.checkedRightRows.length) {
            Message.error(this.$trans(`请选择`));
            return;
        }
        let checkedRightRowIds = _.map(me.checkedRightRows, 'NetworkInterfaceId')
        //不能在循环里面删数组里的数据，会导致最后一个索引对应的item是undefined
        //所以将不被移除的数据存在一个数组里 最后右边的列表数据就是这个数组的数据
        let arrNotDele: any = [];
        let addList: any[] = [];
        _.forEach(me.rightDataClone, function (item, index) {
            //rightChecked=[1,2]  item.Instanced=1 rightData=[{id:1},{id:3}]
            //循环右边列表数据 如果每条item的instanceId在被选中的数组里 那么移除到leftData里
            //并且移除的同时将item.SecurityGroupSet数组里含有当前安全组ID去除(同样不可内部删除)
            if (_.includes(checkedRightRowIds, item.NetworkInterfaceId)) {
                let slicedArr: any = [];
                _.forEach(item.SecurityGroupSet, function (v, k) {
                    if (v != me.groupId) {
                        slicedArr.push(v)
                    }
                })
                item.SecurityGroupSet = slicedArr;
                // me.leftDataClone.unshift(item)
                addList.push(item);

            } else {
                arrNotDele.push(item)
            }
        })
        me.rightDataClone = arrNotDele;

        let allNotAddList: any[] = [];
        allNotAddList = _.filter(me.rightAllData, (item) => {
            return !_.includes(checkedRightRowIds, item.NetworkInterfaceId);
        });
        me.rightAllData = allNotAddList;
        debugger;
        me.rightAllDataClone = allNotAddList;
        me.rightPages.total = allNotAddList.length;
        me.refreshRightData();

        me.leftAllData = addList.concat(me.leftAllData);
        me.leftAllDataClone = me.leftAllData;
        me.leftPages.total = me.leftAllData.length;
        me.refreshLeftData();


    }

    //管理云服务器多安全组 获取已加入安全组网卡信息
    moreKecSafeShow() {
        let me: any = this;
        // apiRequest.DescribeNetworkInterfaces({
        this.request.DescribeNetworkInterfaces({
            Region: me.region,
            SgId: me.groupId
        }, {
            showLoading: false
        }).done((data: any) => {
            //已加入的数据
            let arrKec: any[] = [];
            let addArr: any[] = [];
            _.forEach(data.NetworkInterfaceSet, (item) => {
                if (item.InstanceType == "kec") {
                    item.label = item.InstanceName;
                    item.key = item.InstanceId;
                    addArr.push(item.NetworkInterfaceId)  //已加入的id放一个数组里来筛选未加入的
                    if (item.SecurityGroupSet.length == 1) {
                        item.disabled = true;
                    }
                    arrKec.push(item);
                }
            })
            me.rightData = arrKec;
            me.rightAllData = arrKec;
            me.rightAllDataClone = arrKec;
            me.rightPages.total = arrKec.length;
            me.refreshRightData();

            me.DescribeNetworkInterfacesExtend({
                Region: me.region,
                SgId: me.groupId
            }).then((data: any) => {
                    //已加入的数据
                let arrKec: any[] = [];
                let addArr: any[] = [];
                _.forEach(data.NetworkInterfaceSet, (item) => {
                    if (item.InstanceType == "kec") {
                        item.label = item.InstanceName;
                        item.key = item.InstanceId;
                        addArr.push(item.NetworkInterfaceId)  //已加入的id放一个数组里来筛选未加入的
                        if (item.SecurityGroupSet.length == 1) {
                            item.disabled = true;
                        }
                        arrKec.push(item);
                    }
                })
                me.rightData = arrKec;
                me.rightAllData = arrKec;
                me.rightAllDataClone = arrKec;
                me.rightPages.total = arrKec.length;
                me.refreshRightData();
            })



            me.DescribeNetworkInterfacesExtendFirst().then((data: any) => {
                let leftDataArr: any[] = [];
                me.networkListAll = data.NetworkInterfaceSet || [];

                //筛选未加入的 原始的左边的列表
                _.forEach(me.networkListAll, function (item) {
                    if (item.InstanceType !== "kec") {
                        return;
                    }
                    if (_.includes(addArr, item.NetworkInterfaceId)) {
                    } else {
                        item.label = item.InstanceName;
                        item.key = item.InstanceId;

                        // if (item.SecurityGroupSet.length >= 5) {
                        console.log(me.EipBindGroupNum, "me.EipBindGroupNum===================");
                        if (item.SecurityGroupSet.length >= me.EipBindGroupNum) {
                            item.disabled = true;
                        }
                        leftDataArr.push(item);
                    }
                })
                me.leftAllData = leftDataArr;
                me.leftAllDataClone = leftDataArr;
                me.leftPages.total = leftDataArr.length;
                me.refreshLeftData();
            })

            me.DescribeNetworkInterfacesExtend().then((data: any) => {
                let leftDataArr: any[] = [];
                me.networkListAll = data.NetworkInterfaceSet || [];

                //筛选未加入的 原始的左边的列表
                _.forEach(me.networkListAll, function (item) {
                    if (item.InstanceType !== "kec") {
                        return;
                    }
                    if (_.includes(addArr, item.NetworkInterfaceId)) {
                    } else {
                        item.label = item.InstanceName;
                        item.key = item.InstanceId;

                        // if (item.SecurityGroupSet.length >= 5) {
                        console.log(me.EipBindGroupNum, "me.EipBindGroupNum===================");
                        if (item.SecurityGroupSet.length >= me.EipBindGroupNum) {
                            item.disabled = true;
                        }
                        leftDataArr.push(item);
                    }
                })
                me.leftAllData = leftDataArr;
                me.leftAllDataClone = leftDataArr;
                me.leftPages.total = leftDataArr.length;
                me.refreshLeftData();
            }).then(() => {

            });

        })
    }

    //管理裸金属服务器多安全组 获取已加入安全组网卡信息
    moreEpcSafeShow() {
        let me: any = this;

        me.DescribeNetworkInterfacesExtendFirst().then((data: any) => {
            let leftDataArr: any[] = [];
            let rightDataArr: any[] = [];
            me.networkListAll = data.NetworkInterfaceSet || [];

            //筛选未加入的 原始的左边的列表
            _.forEach(me.networkListAll, function (item) {
                if (item.InstanceType !== "epc") {
                    return;
                }

                if (_.includes(item.SecurityGroupSet, me.groupId)) {
                    item.label = item.InstanceName;
                    item.key = item.InstanceId;
                    item.disabled = item.SecurityGroupSet.length == 1;
                    rightDataArr.push(item);
                } else {
                    if (item.SecurityGroupSet.length >= me.EipBindGroupNum) {
                        item.disabled = true;
                    }
                    leftDataArr.push(item)
                }
            });

            me.rightData = rightDataArr;
            me.rightAllData = rightDataArr;
            me.rightAllDataClone = rightDataArr;
            me.rightPages.total = rightDataArr.length;
            me.refreshRightData();

            me.leftAllData = leftDataArr;
            me.leftAllDataClone = leftDataArr;
            me.leftPages.total = leftDataArr.length;
            me.refreshLeftData();
        })
        
        me.DescribeNetworkInterfacesExtend().then((data: any) => {
            let leftDataArr: any[] = [];
            let rightDataArr: any[] = [];
            me.networkListAll = data.NetworkInterfaceSet || [];

            //筛选未加入的 原始的左边的列表
            _.forEach(me.networkListAll, function (item) {
                if (item.InstanceType !== "epc") {
                    return;
                }

                if (_.includes(item.SecurityGroupSet, me.groupId)) {
                    item.label = item.InstanceName;
                    item.key = item.InstanceId;
                    item.disabled = item.SecurityGroupSet.length == 1;
                    rightDataArr.push(item);
                } else {
                    if (item.SecurityGroupSet.length >= me.EipBindGroupNum) {
                        item.disabled = true;
                    }
                    leftDataArr.push(item)
                }
            });

            me.rightData = rightDataArr;
            me.rightAllData = rightDataArr;
            me.rightAllDataClone = rightDataArr;
            me.rightPages.total = rightDataArr.length;
            me.refreshRightData();

            me.leftAllData = leftDataArr;
            me.leftAllDataClone = leftDataArr;
            me.leftPages.total = leftDataArr.length;
            me.refreshLeftData();
        }).then(() => {

        });
    }

    _checkLeftHandler(ele: any) {
        this.checkedLeftRows = ele.getCheckedData();
    }

    _checkRightHandler(ele: any) {
        this.checkedRightRows = ele.getCheckedData();
    }

    _changeLeftPages(type: any, c: any, v: any) {
        this.leftPages = {
            ...this.leftPages,
            [type]: v
        };

    }

    _changeRightPages(type: any, c: any, v: any) {
        this.rightPages = {
            ...this.rightPages,
            [type]: v
        };
    }

    kecInclude(id: any, arr: any[]) {
        let include = false;
        for (var i = 0; i < arr.length; i++) {
            if (id == arr[i].NetworkInterfaceId) {
                include = true;
            }
        }
        return include;
    }

    mangerSev() {
        let me: any = this;
        if (me.type == 'kec') {
            me.mangerKec();
        } else {
            me.mangerEpc();
        }
    }

    mangerKec() {
        let me: any = this;
        let urlParams = {
            "Region": me.region
        };
        let arrParam: any[] = [];
        let newArr: any[] = [];
        debugger;
        _.forEach(me.rightData, function (item, key) {
            if (!me.kecInclude(item.NetworkInterfaceId, me.rightAllDataClone)) {
                _.forEach(me.leftAllDataClone, function (v, k) {
                    if (item.NetworkInterfaceId === v.NetworkInterfaceId) {
                        newArr.push(v)
                    }
                })
            }
        })
        
        _.forEach(me.rightAllDataClone, function (item, key) {
            if (!me.kecInclude(item.NetworkInterfaceId, me.rightData)) {
                newArr.push(item)
            }
        })


        //所有被移动和添加的的数据都放在newArr里
        _.forEach(newArr, function (item) {
            let arr: any[] = [];
            _.forEach(item.SecurityGroupSet, function (v, k) {
                arr.push({
                    "SecurityGroupId": v
                })
            })
            arrParam.push({
                "NetworkInterfaceId": item.NetworkInterfaceId,
                "InstanceId": item.InstanceId,
                "SecurityGroupSet": arr,
                "SubnetId": item.SubnetId,
                "PrivateIpAddress": item.PrivateIpAddress
            })
        })

        if (!arrParam.length) {
            Message.error(me.$trans(`修改的网络信息不能为空`));
            return
        }

        let jsonParams = {
            ModifyNetworkInterfaceAttributes: arrParam
        };
        let optionParams = {
            isJSON: true
        };

        // this.request.ModifyNetworkInterfaceAttributes(
        apiRequest.ModifyNetworkInterfaceAttributes(
            [
                urlParams,
                jsonParams
            ],
            optionParams
        ).done((data: any) => {
            let ok: any[] = [];
            let failed: any[] = [];
            let arrAll = me.leftDataClone.concat(me.rightDataClone)
            _.forEach(data, (item) => {
                let name = _.find(arrAll, ['NetworkInterfaceId', item.NetworkInterfaceId]);
                if (name) {
                    name = name.InstanceName || name.PrivateIpAddress;
                } else {
                    name = item.NetworkInterfaceId;
                }

                if (item.Return) {
                    ok.push(`${name} ${me.$trans(`操作成功!`)}!`);
                } else {
                    failed.push(`${name} ${me.$trans(`操作失败`)} ${item.Message}`);
                }
            })

            ok = ok.concat(failed)

            if (failed.length) {
                Message.error(ok.join('<br>'));
            } else {
                Message.success(me.$trans(`操作成功!`));
                setTimeout(function () {
                    me.$router.push({
                        name: me.isTrustVpc ? 'trustGroup' : 'group'
                    })
                }, 1000)
            }
        }).always(() => {
            me.leftAllData = [];
            me.rightData = [];
            me.leftDataClone = [];
            me.rightDataClone = [];
            me.getList();
        })

    }

    mangerEpc() {
        let me: any = this;
        let urlParams = {
            "Region": me.region
        };
        let arrParam: any[] = [];
        let newArr: any[] = [];
        _.forEach(me.rightData, function (item, key) {
            if (!me.kecInclude(item.NetworkInterfaceId, me.rightAllDataClone)) {
                _.forEach(me.leftAllDataClone, function (v, k) {
                    if (item.NetworkInterfaceId === v.NetworkInterfaceId) {
                        newArr.push(v)
                    }
                })
            }
        })
        _.forEach(me.rightAllDataClone, function (item, key) {
            if (!me.kecInclude(item.NetworkInterfaceId, me.rightData)) {
                newArr.push(item)
            }
        })


        //所有被移动和添加的的数据都放在newArr里
        _.forEach(newArr, function (item) {
            let arr: any[] = [];
            _.forEach(item.SecurityGroupSet, function (v, k) {
                arr.push({
                    "SecurityGroupId": v
                })
            })
            arrParam.push({
                "NetworkInterfaceId": item.NetworkInterfaceId,
                "InstanceId": item.InstanceId,
                "SecurityGroupSet": arr,
                "SubnetId": item.SubnetId,
                "PrivateIpAddress": item.PrivateIpAddress
            })
        })

        if (!arrParam.length) {
            Message.error(me.$trans(`修改的网络信息不能为空`));
            return
        }

        let jsonParams = {
            ModifyNetworkInterfaceAttributes: arrParam
        };
        let optionParams = {
            isJSON: true
        };

        // this.request.ModifyNetworkInterfaceAttributesEpc(
        apiRequest.ModifyNetworkInterfaceAttributesEpc(
            [
                urlParams,
                jsonParams
            ],
            optionParams
        ).done((data: any) => {
            let ok: any[] = [];
            let failed: any[] = [];
            let arrAll = me.leftDataClone.concat(me.rightDataClone)
            _.forEach(data, (item) => {
                let name = _.find(arrAll, ['NetworkInterfaceId', item.NetworkInterfaceId]);
                if (name) {
                    name = name.InstanceName || name.PrivateIpAddress;
                } else {
                    name = item.NetworkInterfaceId;
                }

                if (item.Return) {
                    ok.push(`${name} ${me.$trans(`操作成功!`)}!`);
                } else {
                    failed.push(`${name} ${me.$trans(`操作失败`)} ${item.Message}`);
                }
            })

            ok = ok.concat(failed)

            if (failed.length) {
                Message.error(ok.join('<br>'));
            } else {
                Message.success(me.$trans(`操作成功!`));
                setTimeout(function () {
                    me.$router.push({
                        name: me.isTrustVpc ? 'trustGroup' : 'group'
                    })
                }, 1000)
            }
        }).always(() => {
            me.leftAllData = [];
            me.rightData = [];
            me.leftDataClone = [];
            me.rightDataClone = [];
            me.getList();
        })

    }

    onCancel() {
        this.$router.push({
            name: this.isTrustVpc ? 'trustGroup' : 'group'
        })
    }


}
